import React, { useState } from "react";
import { Link } from "react-router-dom";
import MainContent from "@components/content";
import Timeline from "@components/timeline";
import css from "../index.module.css";

const timelineData = [
  {
    status: "Инициатива",
    date: "22 февраля 2026",
    title: "Направлен запрос в Минпросвещения",
    color: "default",
    description:
      "Запрос официальных разъяснений о добровольности использования платформы «МАХ» и праве на альтернативные формы обучения.",
  },
  {
    status: "Регистрация",
    date: "24 февраля 2026",
    title: "Обращение зарегистрировано",
    color: "warning",
    description:
      "Обращение принято к рассмотрению Департаментом цифровой трансформации и приоритетных проектов под № ПГ-МП-6001.",
  },
  {
    status: "Минпросвещения",
    date: "27 февраля 2026",
    title: "Получен официальный ответ",
    color: "success",
    description:
      "Ведомство подтвердило: отсутствие регистрации на платформах не является основанием для отказа в реализации права на образование.",
  },
];

const initialCaseStatus = {
  label: "Разъяснено",
  code: "satisfied",
  variant: "satisfied",
};

const LegalCase4Page = () => {
  const [caseStatus] = useState(initialCaseStatus);

  return (
    <MainContent>
      <div className={css.casePage}>
        <div className={css.caseHeader}>
          <div className={css.caseHeaderTop}>
            <Link to="/legal" className={css.backLink}>
              <span className={css.backIcon}>←</span>
              <span>Назад к делам</span>
            </Link>
            <div
              className={`${css.caseStatus} ${
                css[`caseStatus_${caseStatus.variant}`]
              }`}
            >
              <span className={css.caseStatusDot} />
              <span className={css.caseStatusText}>{caseStatus.label}</span>
            </div>
          </div>
          <h1>Использование платформы «МАХ» в образовании</h1>
          <span className={css.caseMeta}>
            Права несовершеннолетних · 2026 г.
          </span>
        </div>

        <div className={css.caseLayout}>
          <div className={css.caseDescription}>
            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Суть (фабула)</div>
              <p>
                В образовательных учреждениях активно внедряется использование ИС «МАХ» и «Сферум» для организации учебного процесса. Регистрация требует согласия на обработку персональных данных сторонней организацией. Возник вопрос о законности принуждения к использованию этих систем и обеспечении права на образование при отказе от цифровых платформ.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Моя позиция</div>
              <p>
                Согласно ст. 43 Конституции РФ и ФЗ «Об образовании», образование общедоступно. Согласно ФЗ-152, согласие на обработку данных — дело добровольное. Обучающийся вправе требовать традиционных форм получения материалов.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Позиция ведомства</div>
              <p>
                Минпросвещения России разъяснило, что хотя образовательные учреждения автономны в выборе технологий (ст. 28 ФЗ-273), отсутствие регистрации обучающегося на электронных платформах <b>не является основанием</b> для отказа в учете успеваемости и реализации права на образование.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Итог (резюме)</div>
              <p>
                Право на образование первично по отношению к любым цифровым инструментам. Любое давление со стороны образовательного учреждения теперь может быть пресечено ссылкой на письмо Минпросвещения № 04-ПГ-МП-6001.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle} style={{ margin: 0 }}>Материалы</div>
              <div className={css.caseMaterialsList}>
                <a href="https://dash.leecyber.com/drive/shared/1f86666b-894e-48d6-9364-9a544bcfd3d0" className={css.caseMaterialLink} target="_blank" rel="noreferrer">
                  Ответ ведомства
                </a>
              </div>
            </div>
          </div>

          <div className={css.caseTimeline}>
            <div className={css.caseSectionTitle} style={{ marginBottom: 25 }}>Ход дела</div>
            <Timeline data={timelineData} />
          </div>
        </div>
      </div>

      <p className={css.caseDisclaimer}>
        Все представленные дела — результат моей самостоятельной практики. Опубликованные материалы не являются профессиональной юридической консультацией, носят исключительно ознакомительный характер и отражают мое субъективное мнение.
      </p>
    </MainContent>
  );
};

export default LegalCase4Page;